module.exports = __webpack_public_path__ + "img/how1.cce28522.png";